<template>
  <b-navbar toggleable="xl" variant="transparent">
    <b-navbar-brand to="/"
      ><i class="text-danger font-weight-bolder">FX legends</i></b-navbar-brand
    >

    <b-navbar-toggle target="nav-collapse" class="py-50">
      <template #default="{ expanded }">
        <div class="d-flex align-items-center">
          <feather-icon icon="MenuIcon" size="30"/>
        </div>
      </template>
    </b-navbar-toggle>

    <b-collapse id="nav-collapse" is-nav>
      <b-navbar-nav
        class="ml-auto font-weight-bolder h4 align-items-center justify-content-between"
      >
        <b-nav-item class="mr-xl-3 my-xl-0 my-1" link-classes="text-link" to="/"
          >Home</b-nav-item
        >
        <b-nav-item
          class="mr-xl-3 my-xl-0 my-1"
          link-classes="text-link"
          to="/competitions"
          >Competitions</b-nav-item
        >
        <b-nav-item class="mr-xl-3 my-xl-0 my-1" link-classes="text-link"
          >Affiliation</b-nav-item
        >
        <b-nav-item
          class="mr-xl-3 my-xl-0 my-1"
          :to="`/competitions/${$route.params.id}/live`"
          link-classes="text-link"
          >Results</b-nav-item
        >
        <b-nav-item
          class="mr-xl-3 my-xl-0 my-1"
          href="#"
          link-classes="text-link"
          >Contact us</b-nav-item
        >
        <template v-if="userData && Object.keys(userData).length">
          <b-button
            class="mr-xl-2 my-xl-0 my-1"
            variant="outline-light rounded-pill font-weight-bolder"
            to="/"
          >
            Dashboard
          </b-button>
          <b-button
            variant="danger rounded-pill font-weight-bolder"
            @click="logout"
          >
            Logout
          </b-button>
        </template>
        <template v-else>
          <b-button
            class="mr-xl-2 my-xl-0 my-1"
            variant="outline-light rounded-pill font-weight-bolder"
            :to="{ name: 'auth-user-register' }"
          >
            Register
          </b-button>
          <b-button
            variant="info rounded-pill font-weight-bolder"
            :to="{ name: 'auth-user-login' }"
          >
            Login
          </b-button>
        </template>
      </b-navbar-nav>
    </b-collapse>
  </b-navbar>
</template>

<script>
import {
  BNavbar,
  BNavbarBrand,
  BNavbarToggle,
  BCollapse,
  BNavbarNav,
  BNavItem,
  BButton,
  BIcon,
} from "bootstrap-vue";
export default {
  components: {
    BNavbar,
    BNavbarBrand,
    BNavbarToggle,
    BCollapse,
    BNavbarNav,
    BNavItem,
    BButton,
    BIcon,
  },
  computed: {
    userData() {
      return (
        this.$store.state.auth.userData ||
        JSON.parse(localStorage.getItem("userData"))
      );
    },
  },
  methods: {
    async logout() {
      // Remove userData from localStorage
      try {
        const { data } = await this.$http.post("auth/user/logout");
        await localStorage.removeItem("userData");
        await this.$store.dispatch("auth/setUserData", {});
        await localStorage.removeItem("token");
        this.$http.defaults.headers.common["Authorization"] = await ``;
        // Redirect to login page
        this.$router.push({ name: "auth-user-login" });
      } catch (err) {}
    },
  },
};
</script>

<style></style>
